import { alertas } from "../ui/ui.js";
import { actualizarPreciosLugar } from "./actividad_seleccionada.js";

const participantes = [];

/**
 * Marca visualmente un campo con error y le da el foco.
 */
function marcarError(input) {
  input.focus();

  // Solo los inputs de texto soportan select()
  if (typeof input.select === "function") {
    input.select();
  }

  input.classList.add("border-red-500", "ring-2", "ring-red-300");

  setTimeout(() => {
    input.classList.remove("border-red-500", "ring-2", "ring-red-300");
  }, 2000);
}

export function agregarParticipanteDesdeFormulario() {

  const nombreInput = document.getElementById("nom");
  const apellidoInput = document.getElementById("ape");
  const emailInput = document.getElementById("email");
  const telefonoInput = document.getElementById("tel");
  const nacimientoInput = document.getElementById("nacimiento");

  const nombre = nombreInput.value.trim();
  const apellido = apellidoInput.value.trim();
  const email = emailInput.value.trim();
  const telefono = telefonoInput.value.trim();
  const fechaNacimiento = nacimientoInput.value;

  // Validaciones
  if (!nombre) {
    marcarError(nombreInput);
    return alertas({
      type: "warning",
      title: "Campo requerido",
      message: "Por favor ingresa el nombre."
    });
  }

  if (!apellido) {
    marcarError(apellidoInput);
    return alertas({
      type: "warning",
      title: "Campo requerido",
      message: "Por favor ingresa el apellido."
    });
  }

  if (!email) {
    marcarError(emailInput);
    return alertas({
      type: "warning",
      title: "Campo requerido",
      message: "Por favor ingresa el correo electrónico."
    });
  }

  // Validación sencilla del formato del email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    marcarError(emailInput);
    return alertas({
      type: "warning",
      title: "Correo inválido",
      message: "Por favor ingresa un correo electrónico válido."
    });
  }

  if (!fechaNacimiento) {
    marcarError(nacimientoInput);
    return alertas({
      type: "warning",
      title: "Campo requerido",
      message: "Por favor selecciona la fecha de nacimiento."
    });
  }

  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  const fecha = new Date(fechaNacimiento);

  // Calcular edad
  let edad = hoy.getFullYear() - fecha.getFullYear();
  const mes = hoy.getMonth() - fecha.getMonth();

  if (mes < 0 || (mes === 0 && hoy.getDate() < fecha.getDate())) {
    edad--;
  }

  // Edad mínima
  if (edad < 10) {
    marcarError(nacimientoInput);
    return alertas({
      type: "warning",
      title: "Edad no permitida",
      message: "El participante debe tener al menos 10 años para participar en los programas."
    });
  }

  // Máximo de participantes según actividad
  const actividadActual =
    (typeof window !== 'undefined' && document.querySelector('input[name="actividad"]:checked')?.value) ||
    null;

  const maxParticipantes = (actividadActual === "Alberca") ? 2 : 3;

  if (participantes.length >= maxParticipantes) {
    return alertas({
      type: "warning",
      title: "Número máximo de participantes",
      message: actividadActual === "Alberca"
        ? "Para la Piscina Climatizada es obligatorio <strong>exactamente 2 participantes</strong> por reserva."
        : "El máximo permitido son <strong>3 participantes</strong>."
    });
  }

  participantes.push({
    id: Date.now(),
    key_user: crypto.randomUUID(),
    nombre,
    apellido,
    email,
    telefono,
    fecha_nacimiento: fechaNacimiento,
    pais: "España"
  });

  renderListaParticipantes();
  actualizarPreciosLugar();
  if (typeof window.updateResumenSeleccion === 'function') {
    window.updateResumenSeleccion();
  }

  scrollArriba();

  alertas({
    type: "success",
    title: "¡Éxito!",
    message: "Participante almacenado en la lista con éxito.",
    autoClose: 2000
  });

  document.getElementById("form-participante").reset();
}

export function renderListaParticipantes() {
  const container = document.getElementById("lista-participantes");
  container.innerHTML = "";


      const contador = document.getElementById("contador");
      const badge = document.getElementById("contadorBadge");

      contador.textContent = participantes.length;

      badge.classList.remove(
        "bg-red-100", "text-red-700",
        "bg-green-100", "text-green-700"
      );

      if (participantes.length === 0) {
        badge.classList.add("bg-red-100", "text-red-700");
      } else {
        badge.classList.add("bg-green-100", "text-green-700");
      }



  if (participantes.length === 0) {
    container.innerHTML = `
      <p class="text-gray-500 text-center py-8">
        Aún no hay participantes agregados
      </p>
    `;
    return;
  }

  participantes.forEach((p, i) => {
    const div = document.createElement("div");
    div.className =
      "bg-white border rounded-xl p-5 flex justify-between items-center";

    div.innerHTML = `
      <div>
        <strong>${p.nombre} ${p.apellido}</strong><br>
        <span class="text-sm text-gray-600">${p.email}</span>
      </div>

      <button
        onclick="eliminarParticipante(${i})"
        class="text-red-500 hover:text-red-700">
        🗑️
      </button>
    `;

    container.appendChild(div);
  });




}

export function eliminarParticipante(i) {
  participantes.splice(i, 1);
  renderListaParticipantes();
  actualizarPreciosLugar();
  if (typeof window.updateResumenSeleccion === 'function') {
    window.updateResumenSeleccion();
  }
}

export function getParticipantes() {
  return participantes;
}

export function totalParticipantes() {
  return participantes.length;
}



export function getPrecioPorPersona() {
    switch (totalParticipantes()) {
        case 0:
        case 1:
            return 68;
        case 2:
            return 50;
        default:
            return 68;
    }
}



function scrollArriba(suave = true) {
  window.scrollTo({
    top: 0,
    behavior: suave ? "smooth" : "auto"
  });
}


document.getElementById("contadorBadge").addEventListener("click", () => {
  document.getElementById("lista-participantes").scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
});